import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

class AmountWonPage extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <div className="container">
        <div className="well">
          <code>
            TODO: Amount Won Leaderboard
          </code>
        </div>
      </div>
    );
  }
}

// Retrieve data from store as props
function mapStateToProps() {
  return {
  };
}

AmountWonPage.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

AmountWonPage.defaultProps = {
};

AmountWonPage.contextTypes = {
  router: PropTypes.object,
};

export default connect(mapStateToProps)(AmountWonPage);
